export const ANNOUNCEMENT_ITEMS = [
  {
    id: "thomas-kosmala-no4-announcement",
    enabled: true,
    text: {
      sr: "✦ NOVO: Thomas Kosmala No. 4 Après l'Amour 10ml + Mystery Sample • Limited Stock!",
      en: "✦ NEW: Thomas Kosmala No. 4 Après l'Amour 10ml + Mystery Sample • Limited Stock!",
    },
    icon: "→",
    tone: "new-shop",
    action: "openProduct",
    slug: "thomas-kosmala-no-4-apres-lamour",
    priority: 10,
  },
];
